import React from 'react';
import { Link } from 'react-router-dom';

function Routing() {
  return (
    <div>
                             <h3>Routing</h3><br/>
        <span> Please View Routing in `{<Link to="/">HomePage</Link>}`</span>
        
    </div>
  )
}

export default Routing;